import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import SelectField from "../../../components/SelectField";

export default function ParteaDezvStep({ data, errors, update }) {
  const prefix = "partea1";
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <SelectField
        label={data.bilateral ? "Tip prima parte" : "Tip parte care dezvaluie"}
        value={data[`${prefix}Tip`]}
        onChange={update(`${prefix}Tip`)}
        options={[
          { value: "pf", label: "Persoana fizica" },
          { value: "pfa", label: "PFA (Persoana Fizica Autorizata)" },
          { value: "srl", label: "SRL (Societate cu Raspundere Limitata)" },
        ]}
      />

      {data[`${prefix}Tip`] === "pf" && (
        <>
          <InputField label="Nume complet" value={data[`${prefix}Nume`]} onChange={update(`${prefix}Nume`)} placeholder="ex: Popescu Ion" required error={errors[`${prefix}Nume`]} />
          <InputField label="Adresa de domiciliu" value={data[`${prefix}Adresa`]} onChange={update(`${prefix}Adresa`)} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors[`${prefix}Adresa`]} />
          <OptionalFields>
            <InputField label="CNP" value={data[`${prefix}CNP`]} onChange={update(`${prefix}CNP`)} placeholder="ex: 1234567890123" half error={errors[`${prefix}CNP`]} helperText="Optional — poti completa de mana pe document" />
            <InputField label="Serie si nr. CI" value={data[`${prefix}CI`]} onChange={update(`${prefix}CI`)} placeholder="ex: RD 123456" half error={errors[`${prefix}CI`]} helperText="Optional — poti completa de mana pe document" />
          </OptionalFields>
        </>
      )}

      {data[`${prefix}Tip`] === "pfa" && (
        <>
          <InputField label="Denumire PFA" value={data[`${prefix}Denumire`]} onChange={update(`${prefix}Denumire`)} placeholder="ex: Popescu Ion PFA" required error={errors[`${prefix}Denumire`]} />
          <InputField label="CUI" value={data[`${prefix}CUI`]} onChange={update(`${prefix}CUI`)} placeholder="ex: 12345678" required half error={errors[`${prefix}CUI`]} />
          <InputField label="Sediu profesional" value={data[`${prefix}Sediu`]} onChange={update(`${prefix}Sediu`)} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors[`${prefix}Sediu`]} />
          <InputField label="Numele titularului PFA" value={data[`${prefix}Titular`]} onChange={update(`${prefix}Titular`)} placeholder="ex: Popescu Ion" required error={errors[`${prefix}Titular`]} />
          <OptionalFields>
            <InputField label="CNP" value={data[`${prefix}CNP`]} onChange={update(`${prefix}CNP`)} placeholder="ex: 1234567890123" half error={errors[`${prefix}CNP`]} helperText="Optional — poti completa de mana pe document" />
          </OptionalFields>
        </>
      )}

      {data[`${prefix}Tip`] === "srl" && (
        <>
          <InputField label="Denumire societate" value={data[`${prefix}Denumire`]} onChange={update(`${prefix}Denumire`)} placeholder="ex: SC Exemplu SRL" required error={errors[`${prefix}Denumire`]} />
          <InputField label="CUI" value={data[`${prefix}CUI`]} onChange={update(`${prefix}CUI`)} placeholder="ex: RO12345678" required half error={errors[`${prefix}CUI`]} />
          <InputField label="Nr. Reg. Comertului" value={data[`${prefix}RegCom`]} onChange={update(`${prefix}RegCom`)} placeholder="ex: J40/1234/2020" half />
          <InputField label="Sediu social" value={data[`${prefix}Sediu`]} onChange={update(`${prefix}Sediu`)} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors[`${prefix}Sediu`]} />
          <InputField label="Reprezentant legal" value={data[`${prefix}Reprezentant`]} onChange={update(`${prefix}Reprezentant`)} placeholder="ex: Popescu Ion" required error={errors[`${prefix}Reprezentant`]} />
        </>
      )}
    </div>
  );
}
